// ServicesSection.jsx
import React, { useEffect, useState } from "react";
import '../../styles/pages/_home.css';
import hrImg from '../../assets/images/hr-card.png';
import itImg from '../../assets/images/it-card.png';
import bizImg from '../../assets/images/business-card.png';

const coreServices = [
  {
    title: "HR Solutions",
    link: "/services/hr",
    img: hrImg,
    services: [
      "Talent Acquisition",
      "Payroll Management",
      "HRMS Implementation",
      "Performance Management",
      "Compliance",
      "Learning & Development"
    ]
  },
  {
    title: "IT Solutions",
    link: "/services/it",
    img: itImg,
    services: [
      "Web Development",
      "Mobile Apps",
      "Cloud Solutions",
      "Cyber Security",
      "AI & Automation",
      "IT Infrastructure"
    ]
  },
  {
    title: "Business Solutions",
    link: "/services/business",
    img: bizImg,
    services: [
      "Business Strategy",
      "Digital Transformation",
      "Process Optimization",
      "Market Research",
      "Corporate Training",
      "Growth Consulting"
    ]
  }
];
export default function ServicesSection() {
  const [activeIndex, setActiveIndex] = useState([0, 0, 0]);

useEffect(() => {
  const interval = setInterval(() => {
    setActiveIndex((prev) =>
      prev.map((current, cardIndex) => {
        const total = coreServices[cardIndex].services.length;
        return (current + 1) % total;
      })
    );
  }, 2500);

  return () => clearInterval(interval);
}, []);
  return (
    <section className="services-section">
      <div className="services-container">
        <h2 className="services-heading">
          Our Services
        </h2>
        <div className="services-cards">
          {coreServices.map((service, idx) => (
            <a key={idx} href={service.link} className="service-card">
              <div className="service-img-container">
                <img src={service.img} alt={service.title} className="service-img" />
              </div>
              <div className="service-text-content">
  <h3 className="service-title">{service.title}</h3>

  <div className="service-rotator">
    ✓ {service.services[activeIndex[idx]]}
  </div>

  <span className="popup">
    Click to know more →
  </span>
</div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
